// ── Physics ──
export const TILE = 32;
export const GRAVITY = 0.48;
export const MOVE_SPEED = 3.9;
export const ACCEL = 0.38;
export const JUMP_FORCE = -9.5;
export const DOUBLE_JUMP_FORCE = -6.35;
export const FRICTION = 0.82;
export const MAX_JUMPS = 2;
export const FALL_GRAVITY = 0.5;
export const APEX_GRAVITY = 0.4;
export const APEX_VY_THRESHOLD = 4.0;
export const MAX_FALL_SPEED = 12;
export const DOUBLE_JUMP_HBOOST = 5.5;
export const CLIMB_SPEED = 3.0;
export const DASH_SPEED = 12;
export const SLIDE_FRICTION = 0.95;

// ── Combat ──
export const MAX_HP = 100;
export const HURT_DURATION = 400;
export const DYING_DURATION = 500;
export const COMBAT_PROFILES = {
  pve: {
    hurtDuration: 260,
    hurtGrace: 140,
    hitStop: 45,
    knockbackX: 2.2,
  },
  pvp: {
    hurtDuration: 160,
    hurtGrace: 100,
    hitStop: 25,
    knockbackX: 1.4,
  },
};

// ── Rendering ──
export const ORIGIN_X = 0.5309;
export const ORIGIN_Y = 0.8921;
export const MAP_SCALE = 0.6;
